import { render, staticRenderFns } from "./SampleCertificateBlank.vue?vue&type=template&id=28dd4df0&scoped=true&"
import script from "./SampleCertificateBlank.vue?vue&type=script&lang=js&"
export * from "./SampleCertificateBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dd4df0",
  null
  
)

export default component.exports